var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white text-align-center"},[_c('p',[_c('span',{staticClass:"card-text-md cl-gray-72"},[_vm._v(" Acrescente módulos em "+_vm._s(_vm.message)+" usando o menu da esquerda ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }